import '@archetype-themes/scripts/vendors/flickity';

class SomibeyaCarousel extends HTMLElement {
  connectedCallback() {
    if (this.slider) return;
    this.track = this.querySelector('.somi-carousel__track');
    this.slides = [...this.querySelectorAll('.somi-carousel__slide')];
    if (this.slides.length < 2) return;
    this.events = new AbortController();
    const options = {signal: this.events.signal};
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.slider = new window.Flickity(this.track, {
      cellSelector: '.somi-carousel__slide', cellAlign: 'center', wrapAround: true,
      prevNextButtons: false, pageDots: false, autoPlay: false,
      accessibility: false, setGallerySize: false, dragThreshold: 8, selectedAttraction: .04, friction: .3
    });
    this.querySelector('.somi-carousel__controls').hidden = false;
    const go = index => this.slider.select(index, true, reducedMotion.matches);
    this.querySelectorAll('[data-direction]').forEach(button => {
      button.addEventListener('click', () => go(this.slider.selectedIndex + (button.dataset.direction === 'next' ? 1 : -1)), options);
    });
    this.dots = [...this.querySelectorAll('[data-slide]')];
    this.dots.forEach(button => button.addEventListener('click', () => go(Number(button.dataset.slide)), options));
    this.track.addEventListener('keydown', event => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      go(this.slider.selectedIndex + (event.key === 'ArrowRight' ? 1 : -1));
      this.track.focus({preventScroll:true});
    }, options);
    const update = (announce = false) => {
      const current = this.slider.selectedIndex;
      this.dots.forEach((dot, i) => {
        if (i === current) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
      this.slides.forEach((slide, i) => {
        slide.setAttribute('aria-hidden', String(i !== current));
        slide.querySelectorAll('a').forEach(link => link.tabIndex = i === current ? 0 : -1);
      });
      if (announce) this.querySelector('[data-carousel-status]').textContent = `${current + 1} / ${this.slides.length}`;
    };
    this.slider.on('change', () => update(true));
    update();
    let trackSize = `${this.track.clientWidth}:${this.track.clientHeight}`;
    this.resizeObserver = new ResizeObserver(() => {
      const nextSize = `${this.track.clientWidth}:${this.track.clientHeight}`;
      if (nextSize === trackSize) return;
      trackSize = nextSize;
      this.slider.resize();
      this.slider.reposition();
    });
    this.resizeObserver.observe(this.track);
    this.addEventListener('shopify:block:select', event => {
      const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
      if (index >= 0) go(index);
    }, options);
  }
  disconnectedCallback() {
    this.events?.abort();
    this.resizeObserver?.disconnect();
    this.slider?.destroy();
    this.slider = null;
  }
}
if (!customElements.get('somibeya-carousel')) customElements.define('somibeya-carousel', SomibeyaCarousel);
